<div class="dialog-header">
  <div class="header-title"><span style="font-size: 145%;">Project Activity</span></div>

  <button mat-button class="close-button-container" mat-dialog-close disableRipple="true">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content activity-dialog" [ngClass]="{'disabled-content': loadingSpinner}">

  <form #projectActivityForm="ngForm">
    <div class="form-block">
      <div class="form-row">
        <div class="icon-block">
          <mat-icon>format_list_bulleted</mat-icon>
        </div>
        <div class="field-block">
          <!-- <mat-select *ngIf="selectedType" [(value)]="selectedType">
            <mat-select-trigger>{{selectedType.title}}</mat-select-trigger>
            <mat-option *ngFor="let type of activityTypes" [value]="type">
              <span class="type-text">{{type.title}}</span>
            </mat-option>
          </mat-select> -->

          <p-dropdown [ngModelOptions]="{standalone: true}" [disabled]="!newActivity"
                      [options]="activityTypes" [(ngModel)]="selectedType" optionLabel="title"
                      (onChange)="typeChanged()"></p-dropdown>
        </div>
      </div>
      <div class="form-row">
        <div class="icon-block">
          <mat-icon>person</mat-icon>
        </div>
        <div class="field-block">
          <p-dropdown [ngModelOptions]="{standalone: true}" [options]="users" [(ngModel)]="selectedUser"
                      placeholder="No User Assigned" optionLabel="username" (onChange)="checkForOverlapping()"
                      [disabled]="usersIsLoading"></p-dropdown>
        </div>
      </div>
      <div class="form-row">
        <div class="icon-block">
          <mat-icon>group_add</mat-icon>
        </div>
        <div class="field-block">
          <p-multiSelect [ngModelOptions]="{standalone: true}" [options]="users" [(ngModel)]="selectedAdditionalUsers"
                         placeholder="Additional Users" optionLabel="username" display="chip"
                         [disabled]="usersIsLoading"></p-multiSelect>
        </div>
      </div>
      <div class="form-row" *ngIf="newActivity">
        <div class="icon-block switch-block">
          <p-inputSwitch [ngModelOptions]="{standalone: true}" [(ngModel)]="useWorkloadMode" (onChange)="getInitData()">
          </p-inputSwitch>
        </div>
        <div class="field-block">
          <span>Use Workload Calculation (BETA)</span>
        </div>
      </div>
      <div class="form-row calendar-row">
        <div class="icon-block">
          <mat-icon>calendar_today</mat-icon>
        </div>
        <div class="field-block calendar-block">
          <p-calendar #dateRangePicker [(ngModel)]="dateRange" view="date" [panelStyleClass]="'start-date-panel'" selectionMode="range"
                      [showIcon]="true" [ngModelOptions]="{standalone: true}" [tabindex]="-1" [readonlyInput]="false"
                      [showOnFocus]="false" [touchUI]="true" (onShow)="onShown()"
                      (onMonthChange)="monthChanged($event)">
            <ng-template pTemplate="date" let-date>
              <span>{{date.day}}</span>
              <div class="dots-block">
                <div class="dot-activity" *ngFor="let val of activityDots.get(date.day + '')"
                     pTooltip="{{val.val}}" tooltipPosition="bottom"
                     style.background-color="#{{val.color}}">
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate="footer">
              <div class="calendar-footer-buttons">
                <div class="date-info">
                  <div class="date-range-text">{{getDateRangeText()}}</div>
                  <div class="warning-text" *ngIf="getWarningText()">{{getWarningText()}}</div>
                </div>
                <div class="button-group">
                  <button type="button" mat-button (click)="cancelDateSelection()">Cancel</button>
                  <button type="button" mat-button (click)="confirmDateSelection()">Confirm</button>
                </div>
              </div>
            </ng-template>
          </p-calendar>
        </div>
      </div>
      <div class="form-row">
        <div class="icon-block switch-block">
          <p-inputSwitch [ngModelOptions]="{standalone: true}" [(ngModel)]="ignoreTime">
          </p-inputSwitch>
        </div>
        <div class="field-block calendar-block">

          <p-calendar [(ngModel)]="startTime" hourFormat="12" [stepMinute]="15" [disabled]="!ignoreTime"
                      [icon]="'pi pi-clock'" [panelStyleClass]="'start-time-panel'" [timeOnly]="true"
                      [showIcon]="true" [ngModelOptions]="{standalone: true}" [tabindex]="-1" [readonlyInput]="false"
                      [showOnFocus]="false" [touchUI]="true" (onClose)="checkForOverlapping()" (onShow)="blurActiveElement()">
          </p-calendar>

          <!-- <input class="date-time-input" type="datetime-local" [(ngModel)]="startDate"
            [ngModelOptions]="{standalone: true}"> -->

        </div>
      </div>
      <div class="form-row">
        <div class="icon-block">
          <mat-icon>timer</mat-icon>
        </div>
        <div class="field-block duration-block">
          <mat-form-field><input matInput placeholder="Duration in hours" type="number" [required]="true"
                                 [(ngModel)]="activityDuration" name="activityDuration" (ngModelChange)="onDurationChange($event)">
          </mat-form-field>

        </div>
      </div>
      <div class="form-row"
           *ngIf="selectedType.name === 'JobDelivery' || selectedType.name === 'PunchListDue'">
        <div class="icon-block">
          <mat-icon>local_shipping</mat-icon>
        </div>
        <div class="field-block">
          <input class="arrow-input delivery-inst" type="text" pInputText BlockLateralArrowNavigation
                 [ngModelOptions]="{standalone: true}" [placeholder]="'Delivery Instructions'"
                 [(ngModel)]="deliveryInstructions">
        </div>
      </div>
      <div class="form-row" *ngIf="projectActivity?.id && selectedType.name === 'JobDelivery'">
        <div class="icon-block">
          <mat-icon>description</mat-icon>
        </div>
        <div class="field-block files-block">
          <button class="report-button" mat-button (click)="openReport()">Delivery Report</button>
        </div>
      </div>
      <div class="form-row">
        <div class="icon-block">
          <mat-icon>attach_file</mat-icon>
        </div>
        <div class="field-block files-block">
          <app-activity-files (updateFiles)="updateFiles($event)" [projectId]="project.id"
                              [activity]="projectActivity" [status]="buttonLabel">
          </app-activity-files>

        </div>
      </div>

      <div class="form-row"
           *ngIf="projectActivity && selectedType?.name === 'Installation' && currentUser.adminNSales">
        <div class="icon-block">
          <mat-icon>home_repair_service</mat-icon>
        </div>
        <div class="field-block">
          <app-activity-requests [projectActivity]="projectActivity"
                                 (updateUser)="updateSelectedUser($event)"></app-activity-requests>
        </div>
      </div>
    </div>
    <div class="save-btn-block">
      <div class="flex-box">

      </div>
      <button mat-button class="save-btn" (click)="saveActivityButton()"
              [disabled]="!projectActivityForm.form.valid" tabindex="1" type="submit">
        <span *ngIf="!loadingSpinner">{{buttonLabel}}</span>
        <lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
      </button>
      <div class="flex-box">
        <button *ngIf="buttonLabel === 'Save'" mat-button class="delete-item-button"
                (click)="deleteProjectActivity()">
          <mat-icon *ngIf="!deleteLoadingSpinner">delete</mat-icon>
          <lib-mini-progress-spinner *ngIf="deleteLoadingSpinner"></lib-mini-progress-spinner>
        </button>
      </div>
    </div>
  </form>
</div>


<p-confirmDialog appendTo="body" icon="pi pi-exclamation-triangle" styleClass="schedule-panel">
</p-confirmDialog>
